import React, { useEffect, useState } from 'react';
import anniversaryBackground from '../images/anniversary/background.jpg';
import anniversaryMark from '../images/anniversary/mark.png';
import anniversaryMarkMobile from '../images/anniversary/mark-mobile.png';
import anniversaryTag from '../images/anniversary/tag.svg';

export const ANNIVERSARY_CAMPAIGN_START_AT = Date.UTC(2026, 6, 25, 0, 0, 0);
export const ANNIVERSARY_CAMPAIGN_END_AT = Date.UTC(2026, 7, 26, 0, 0, 0);
export const ANNIVERSARY_COUPON_CODE = '25FOR25';

const MAX_TIMEOUT_DELAY = 2147483647;

function isAnniversaryPreviewRequested() {
    if (typeof window === 'undefined') return false;
    return window.location.search.indexOf('previewAnniversary=1') !== -1;
}

export function isAnniversaryCampaignActive(now = Date.now()) {
    if (isAnniversaryPreviewRequested()) return true;
    return now >= ANNIVERSARY_CAMPAIGN_START_AT && now < ANNIVERSARY_CAMPAIGN_END_AT;
}

function getNextBoundary(now) {
    if (now < ANNIVERSARY_CAMPAIGN_START_AT) return ANNIVERSARY_CAMPAIGN_START_AT;
    if (now < ANNIVERSARY_CAMPAIGN_END_AT) return ANNIVERSARY_CAMPAIGN_END_AT;
    return null;
}

const AnniversaryPromo = () => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        let timer;

        const scheduleRefresh = () => {
            const now = Date.now();
            setActive(isAnniversaryCampaignActive(now));

            const boundary = getNextBoundary(now);
            if (boundary === null) return;

            const delay = Math.min(Math.max(boundary - now + 50, 50), MAX_TIMEOUT_DELAY);
            timer = setTimeout(scheduleRefresh, delay);
        };

        scheduleRefresh();
        return () => clearTimeout(timer);
    }, []);

    if (!active) return null;

    const brandClass = process.env.BRAND === 'ut' ? 'anniversary-promo-ut' : 'anniversary-promo-bt';
    return (
        <section className={`anniversary-promo ${brandClass}`} aria-label="25th Anniversary promotion">
            <img className="anniversary-promo-background" src={anniversaryBackground} alt="" />
            <div className="anniversary-promo-content">
                <picture className="anniversary-promo-mark">
                    <source media="(max-width: 900px)" srcSet={anniversaryMarkMobile} />
                    <img src={anniversaryMark} alt="25th Anniversary" />
                </picture>
                <div className="anniversary-promo-coupon">
                    <span className="anniversary-promo-tag" aria-hidden="true">
                        <img src={anniversaryTag} alt="" />
                    </span>
                    <div className="anniversary-promo-coupon-copy">
                        <span className="anniversary-promo-coupon-label">Enter Coupon Code At Checkout</span>
                        <strong>{ANNIVERSARY_COUPON_CODE}</strong>
                    </div>
                </div>
                <div className="anniversary-promo-offer">
                    <div className="anniversary-promo-discount">
                        <strong>25%</strong>
                        <span>
                            <b>Off</b>
                            PRO Annual Plan
                        </span>
                    </div>
                    <div className="anniversary-promo-dates">
                        <em>2026</em>
                        <strong>7.25 <i /> 8.25</strong>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AnniversaryPromo;
